const ruleFormSet = {}

const ruleGroupFormSet = {}

const ruleCollectionFormSet = {}

export { ruleFormSet, ruleGroupFormSet, ruleCollectionFormSet }
